import React, { useState, useEffect } from 'react';
import { useHistory } from "react-router-dom";

import { apiGet, getTransactionApiUrl, getAdminApiUrl } from '../common/AppApi';

import Strings from '../common/Strings';

import TransactionSearch from '../program/TransactionSearch';

export default function Transactions() {
    let [showSpinner, setSpinner] = useState(false);
    let [message, setMessage] = useState();
	let [programs, setPrograms] = useState([]);

	let getPrograms = () => {
		setSpinner(true);
		let url = getAdminApiUrl() + '/programs';

		apiGet(url).then((resp)=> {
			let programs = [];
			programs.push({id:'',text:''});
			resp.forEach( (p) => {
				programs.push({id:p.programUuid,text:p.programName,id2:p.programId});
			});
			setPrograms(programs);
		}).catch( (err)=> {
			console.error(err);
			let messageObject = {text:Strings.error.general,type:'danger'};
			if(err.privilegeError){
				messageObject.text = <>{err.message}</>;
			}
			setMessage(messageObject);
		}).finally(() => setSpinner(false));
	};

	useEffect(() => {
		getPrograms();
	}, []);

    return (
        <>
        <TransactionSearch programs={programs} basePath="/admin"/>
        </>
    )
}
